import { useEffect } from 'react';
import { cards } from '../../lib/api/api';
import { HandySvg } from 'handy-svg';
import iconDeleteCross from '../../assets/icons/svg-sprite/delete-cross--round.svg';
import iconPointerRight from '../../assets/icons/svg-sprite/point-arrow-right.svg';

const ServiceSwitch = ({ID, packageToDelete, setPackageToDelete, changeMessage}) => {

    useEffect(() => {
        if (ID !== null) {
            submitForm();
        }
    }, [ID]);

    function submitForm() {
        const formElement = document.getElementById('service-switch')
        formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(formElement);
            const billing_service_code = formData.get('service_code');
            setPackageToDelete({});
            const banner = document.getElementById('messageBanner');
            banner.style.removeProperty('display');
            cards.deleteSubscription(ID, billing_service_code)
                .then(() => {
                    changeMessage('Заявка на изменение подписки успешно создана!');
                })
                .catch((err) => {
                    changeMessage('Ошибка отключения, попробуйте позже');
                    console.log(err);
                });
        });
    }

    return (
        <>
            <div className={"service-switch" + (Object.keys(packageToDelete).length === 0 ? " service-switch--hidden" : "")}>
                <form id='service-switch' className="service-switch__inner page-container" method="POST">
                    <div className="service-switch__selections">
                        <span className="service-switch__selections-label service-switch__label">Вы планируете отключить:</span>
                        <ul className="service-switch__selections-list">
                            {Object.keys(packageToDelete).length === 0 ? '' : (
                                <li className="service-switch__selection">
                                    <input type='hidden' name='service_code' value={packageToDelete.billing_service_code}/>
                                    <span className="service-switch__selection-name">{packageToDelete.name}</span>
                                    <button
                                        className="service-switch__selection-delete bttn"
                                        type="button"
                                        onClick={() => {
                                            setPackageToDelete({});
                                    }}>
                                        <HandySvg className="svg-icon" src={iconDeleteCross} width="28" height="28"/>
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="service-switch__continue">
                        <button className="service-switch__continue-btn bttn" type='submit'>
                            <span className="service-switch__continue-btn-text">Отключить</span>
                            <HandySvg className="svg-icon" src={iconPointerRight} width="19" height="10"/>
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ServiceSwitch;